 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML0001_COVER from '@/components/xhtml/0001_cover'
 import XHTML0002_COPYRIGHTTITLE from '@/components/xhtml/0002_copyright-title'
 import XHTML0003_DEDICATION from '@/components/xhtml/0003_dedication'
 import XHTML0004_ACK from '@/components/xhtml/0004_ack'
 import XHTML0006_INTRODUCTION from '@/components/xhtml/0006_introduction'
 import XHTML0007_CHAPTERTITLE001 from '@/components/xhtml/0007_chapter-title-001'
 import XHTML0008_CHAPTERTITLE002 from '@/components/xhtml/0008_chapter-title-002'
 import XHTML0009_PROJ from '@/components/xhtml/0009_proj'
 import XHTML0010_CHAPTERTITLE003 from '@/components/xhtml/0010_chapter-title-003'
 import XHTML0011_CHAPTERTITLE004 from '@/components/xhtml/0011_chapter-title-004'
 import XHTML0012_CHAPTERTITLE005 from '@/components/xhtml/0012_chapter-title-005'
 import XHTML0013_CHAPTERTITLE006 from '@/components/xhtml/0013_chapter-title-006'
 import XHTML0014_CHAPTERTITLE007 from '@/components/xhtml/0014_chapter-title-007'
 import XHTML0015_CHAPTERTITLE008 from '@/components/xhtml/0015_chapter-title-008'
 import XHTML0016_ABOUTTITLE from '@/components/xhtml/0016_about-title'
 import XHTML0017_RESOURCES from '@/components/xhtml/0017_resources'
 import XHTML0134_CREDITSTITLE from '@/components/xhtml/0134_credits-title'
 import XHTML0135_BACKMATTER from '@/components/xhtml/0135_backmatter'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/0001_cover",
 			"name" : "xhtml/0001_cover",
 			"component" : XHTML0001_COVER
 		},
 		{
 			"path" : "/xhtml/0002_copyright-title",
 			"name" : "xhtml/0002_copyright-title",
 			"component" : XHTML0002_COPYRIGHTTITLE
 		},
 		{
 			"path" : "/xhtml/0003_dedication",
 			"name" : "xhtml/0003_dedication",
 			"component" : XHTML0003_DEDICATION
 		},
 		{
 			"path" : "/xhtml/0004_ack",
 			"name" : "xhtml/0004_ack",
 			"component" : XHTML0004_ACK
 		},
 		{
 			"path" : "/xhtml/0006_introduction",
 			"name" : "xhtml/0006_introduction",
 			"component" : XHTML0006_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/0007_chapter-title-001",
 			"name" : "xhtml/0007_chapter-title-001",
 			"component" : XHTML0007_CHAPTERTITLE001
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js